import { useTranslation } from '@framework/i18n';
import { Collapse } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const CollapsibleAreaCollapse = styled(Collapse)`
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    display: none;
  }
`;
const CollapsibleAreaCollapsePanel = styled(Collapse.Panel)`
  .ant-collapse-content-box {
    padding: 0; // in alcuni casi il padding non viene modificato... ma va bene cosi per ora, non forzare con &&&.
    background-color: ${props => props.theme.colorBgContainer};
  }
`;

export interface ICollapsibleAreaProps
  extends Omit<
    React.HTMLAttributes<HTMLDivElement>,
    'id' | 'role' | 'aria-labelledby'
  > {
  opened: boolean;
  id: string;
  buttonId?: string;
}

/**
 * Area collassabile nascosta per mostrare elementi dinamici
 *
 * @param opened Indica se il pannello è aperto o chiuso
 * @param id Obbligatorio per accessibilità, va associato al pulsante di apertura (aria-controls)
 * @param buttonId per accessibilità, sarà associato al pannello (aria-labelledby)
 */
export function CollapsibleArea(props: ICollapsibleAreaProps) {
  const { opened, id, buttonId, children, ...divProps } = props;
  const { t } = useTranslation();

  return (
    <div
      style={{ maxWidth: '100%', overflowX: 'auto' }}
      {...divProps}
      id={id}
      role="region"
      aria-labelledby={buttonId ?? undefined}
    >
      <CollapsibleAreaCollapse activeKey={[opened ? 'opened' : '']} ghost>
        <CollapsibleAreaCollapsePanel
          className="collapsible-area-panel"
          header={t(
            'collapse.collapsible-area.hidden-header',
            'Collapsible Area',
          )}
          key="opened"
        >
          {children}
        </CollapsibleAreaCollapsePanel>
      </CollapsibleAreaCollapse>
    </div>
  );
}
